// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"add417d0","622":"cce2e981","977":"2f16bd03"}[chunkId] + ".chunk.js";
};